import React from 'react';
import styled from 'styled-components';
import { FilledButton, FlexColumn } from '@make-software/tg-mini-app-ui';

import { SecondaryText, TitleRow, useClaimGift, ClaimSubnameModal, MakeSubnamePrimaryModal } from '@/shared';
import { INCOMPLETE_CRITERIA_MESSAGE, SUCCESS_MESSAGE } from '@/constants';


import { DomainSearchInput } from '../domain-search-input';
import { StatusMessage } from './styled';
import { RoundContainer } from '../styled';

export const Space = styled.div`
  margin-top: 12px;
`;

export const ClaimGift: React.FC = () => {
  const {
    subname,
    searchError,
    hasIncompleteCriteria,
    isInputDisabled,
    isSearchDisabled,
    isNameAvailable,
    hasAssignedSubname,
    handleSubnameChange,
    handleSearchSubname,
    onGetSubnameClick,
    claimStatus,
    isClaimModalOpen,
    isMakePrimaryModalOpen,
    makePrimaryStatus,
    onMakeSubnamePrimary,
    submitting,
    onModalClose,
    isPrimary
  } = useClaimGift();

  return (
    <RoundContainer>
      <FlexColumn gap={8}>
        <TitleRow weight={1} color="#FFFFFF" size="lg" margin="0">
          Claim Your Gift
        </TitleRow>

        <SecondaryText weight={3} size="md" color="#FFFFFF">
          Enter the subname you want.
        </SecondaryText>
      </FlexColumn>

      <Space />

      <DomainSearchInput
        value={subname}
        onChange={handleSubnameChange}
        onSearch={handleSearchSubname}
        disabled={isSearchDisabled}
        inputDisabled={isInputDisabled}
      />

      <Space />

      {hasIncompleteCriteria && (
        <StatusMessage weight={3}>{INCOMPLETE_CRITERIA_MESSAGE}</StatusMessage>
      )}
      {searchError && <StatusMessage weight={3}>{searchError}</StatusMessage>}
      {isNameAvailable && !searchError && !hasAssignedSubname && (
        <StatusMessage weight={3} success>
          {SUCCESS_MESSAGE}
        </StatusMessage>
      )}

      {hasAssignedSubname ? (
        <FilledButton
          title="Make it primary"
          disabled={isPrimary || submitting}
          onClick={onMakeSubnamePrimary}
        />
      ) : (
        <FilledButton
          title="Get your name"
          disabled={!isNameAvailable || hasIncompleteCriteria || submitting}
          onClick={onGetSubnameClick}
          fontFamily="Inter"
          disabledStyles={{ backgroundColor: '#30313b' }}
        />
      )}

      <ClaimSubnameModal
        isOpen={isClaimModalOpen}
        onClose={onModalClose('claim')}
        status={claimStatus}
        onMakePrimary={onMakeSubnamePrimary}
      />
      <MakeSubnamePrimaryModal
        isOpen={isMakePrimaryModalOpen}
        status={makePrimaryStatus}
        onClose={onModalClose('makePrimary')}
      />
    </RoundContainer>
  );
};
